module.exports = __webpack_public_path__ + "static/191009-BS-IGB-Lobby-Blade-n-Ghoul-917dfa3b92b97f2575ddc7fa8bf757cf.jpg";